import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { name: "pantry-camera-check-view" }
const _hoisted_2 = { name: "pantry-camera-check-data-view" }
const _hoisted_3 = { class: "pantry-camera-check-view-item-text" }
const _hoisted_4 = { class: "pantry-camera-check-view-select-view" }
const _hoisted_5 = { class: "pantry-camera-check-view-food-area" }
const _hoisted_6 = { class: "pantry-camera-check-view-text-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryCameraCheckImageView = _resolveComponent("PantryCameraCheckImageView")
  const _component_PantrySelectCategory = _resolveComponent("PantrySelectCategory")
  const _component_PantryFoodCheckItem = _resolveComponent("PantryFoodCheckItem")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "pantry-camera-check-view-image-view-image",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickImageView(...args))),
        onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickImageView(...args)))
      }, [
        _createVNode(_component_PantryCameraCheckImageView, {
          class: "pantry-camera-check-view-image-view",
          key: _ctx.updateSelectItemKey,
          data: _ctx.candidateData,
          selectPosition: _ctx.selectPosition,
          update: _ctx.update,
          onImageFileName: _ctx.callbackImageFileName
        }, null, 8, ["data", "selectPosition", "update", "onImageFileName"])
      ], 32),
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getFoodName()), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_PantrySelectCategory, {
          categoryNameList: _ctx.categoryNameList,
          selectIndex: _ctx.selectNo,
          onOnSelect: _ctx.selectCategory
        }, null, 8, ["categoryNameList", "selectIndex", "onOnSelect"])
      ]),
      _createVNode(_component_PantryFoodCheckItem, {
        class: "pantry-camera-check-view-main-food",
        data: _ctx.getMainFood(),
        isLarge: true,
        isFoodTimerExec: _ctx.isFoodTimerExec,
        onClickFood: _ctx.onClickFood
      }, null, 8, ["data", "isFoodTimerExec", "onClickFood"]),
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getFoodList(), (item) => {
          return (_openBlock(), _createBlock(_component_PantryFoodCheckItem, {
            class: "pantry-camera-check-view-food",
            key: item.ingredientId,
            data: item,
            isLarge: false,
            isFoodTimerExec: _ctx.isFoodTimerExec,
            onClickFood: _ctx.onClickFood
          }, null, 8, ["data", "isFoodTimerExec", "onClickFood"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          class: "pantry-camera-check-view-text",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickInput(...args)))
        }, "その他の食材")
      ])
    ], 512), [
      [_vShow, _ctx.isShowData()]
    ])
  ], 512)), [
    [_vShow, _ctx.isShow()]
  ])
}